import { render, staticRenderFns } from "./CategoryListView.vue?vue&type=template&id=25b9af31&"
import script from "./CategoryListView.vue?vue&type=script&lang=js&"
export * from "./CategoryListView.vue?vue&type=script&lang=js&"
import style0 from "./CategoryListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports